import { Style } from '@/components/style';
import PropTypes from 'prop-types';
import PagerCode from './components/pagerCode';
import WelcomePhone from './components/welcomePhone';
import WelcomeName from './components/welcomeName';
import WelcomeTakeoutSelector from './components/welcomeTakeoutSelector';
import WelcomePreordertimeSelector from './components/welcomePreorderTimeSelector';
import WelcomeAddress from './components/welcomeAddress';
import WelcomeComment from './components/welcomeComment';
import ShareMealLayout from './components/shareMeal';
import WelcomeReminder from './components/welcomeReminder';
import ExistingOrderBtnWelcome from './components/existingOrderBtnWelcome';

function WelcomeForm({
  webStoreVo,
  orderVo,
  selectedServeType,
  selectedTakeOutServeType,
  setSelectedTakeOutServeType,
}) {
  return (
    <div>
      {/* 手機 */}
      <WelcomePhone
        webStoreVo={webStoreVo}
        selectedServeType={selectedServeType}
        selectedTakeOutServeType={selectedTakeOutServeType}
      />
      {/* 叫號器 */}
      <PagerCode pagerCode={orderVo?.pagerCode} />
      {/* 姓名 */}
      <WelcomeName
        webStoreVo={webStoreVo}
        selectedServeType={selectedServeType}
        selectedTakeOutServeType={selectedTakeOutServeType}
      />
      {/* 外帶 選擇訂單時間 */}
      <WelcomeTakeoutSelector
        webStoreVo={webStoreVo}
        selectedServeType={selectedServeType}
        selectedTakeOutServeType={selectedTakeOutServeType}
        setSelectedTakeOutServeType={setSelectedTakeOutServeType}
      />

      {/* 預約時間 */}
      <WelcomePreordertimeSelector
        webStoreVo={webStoreVo}
        orderVo={orderVo}
        selectedServeType={selectedServeType}
        selectedTakeOutServeType={selectedTakeOutServeType}
        setSelectedTakeOutServeType={setSelectedTakeOutServeType}
      />

      {/* 地址 ( 一般輸入 下拉選單 uberDirect) */}
      <WelcomeAddress
        webStoreVo={webStoreVo}
        orderVo={orderVo}
        selectedServeType={selectedServeType}
        selectedTakeOutServeType={selectedTakeOutServeType}
        setSelectedTakeOutServeType={setSelectedTakeOutServeType}
      />
      {/* 備註 */}
      <WelcomeComment
        webStoreVo={webStoreVo}
        selectedServeType={selectedServeType}
      />

      {/* 共鍋費 */}
      <ShareMealLayout
        webStoreVo={webStoreVo}
        orderVo={orderVo}
        selectedServeType={selectedServeType}
      />

      {/* 文字提示區 */}
      <WelcomeReminder
        selectedServeType={selectedServeType}
        selectedTakeOutServeType={selectedTakeOutServeType}
      />

      {/* 既有訂單 */}
      <ExistingOrderBtnWelcome
        webStoreVo={webStoreVo}
        orderVo={orderVo}
        selectedServeType={selectedServeType}
      />
    </div>
  );
}

WelcomeForm.defaultProps = {};

WelcomeForm.propTypes = {
  webStoreVo: PropTypes.shape({
    availableServeTypes: PropTypes.arrayOf(PropTypes.string),
    availableTakeOutServeTypes: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  orderVo: PropTypes.shape({}).isRequired,
  selectedServeType: PropTypes.string.isRequired,
  selectedTakeOutServeType: PropTypes.string.isRequired,
  setSelectedTakeOutServeType: PropTypes.func.isRequired,
};

export default WelcomeForm;
